export default "__VITE_ASSET__CLOO37oh__"